// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608310015/js/" + chunkId + "." + {"44":"89e39134","225":"f619dd2c","481":"f9edc471","486":"c6b766a3","770":"67f3e792"}[chunkId] + ".0.32417885843200145.chunk.js";
};